import React, {useState, useEffect, useRef} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {functions} from "../../../constants/common-functions";
import {STRINGIFY} from "../../../constants/general-constants";
import {INPUT_TYPE_TEXT} from "../../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../../constants/input-types";
import EditChildPanel from '../components/EditChildPanel';
import {YES_NO_OPTIONS} from "../../../constants/general-constants";

export default function AdminListPanelGeographies({id}){
	
	const [geographies, setGeographies] = useState([]);
	const [childId, setChildId] = useState("-100");
	const [childName, setChildName] = useState("-100");
	const [childEditDisplay, setChildEditDisplay] = useState("none");
	
	const refChildCode = useRef(null);
	const refChildName = useRef(null);
	const refChildDescription = useRef(null);
	const refChildIsCountry = useRef(null);
	
	useEffect(() => {
		
		loadChildren();
	}, [id]);
	
	const loadChildren = () => {
		functions.getArrayFromAjax("/resolution/geographiesforparent?parentId=" + id,  null, populateGeographies);
	};
	
	const childComponentRows = [
		{ref:refChildCode, id:"1", title:"Code", inputType:INPUT_TYPE_TEXT},
		{ref:refChildName, id:"2", title:"Name", inputType:INPUT_TYPE_TEXT},
		{ref:refChildDescription, id:"4", title:"Description", inputType:INPUT_TYPE_TEXTAREA},
		{ref:refChildIsCountry, id:"5", title:"Is Country?", inputType:INPUT_TYPE_SELECT, options:YES_NO_OPTIONS}
	];
	
	const populateGeographies = (results) => {
		let tempGeographies = [];
		for(let i=0; i<results.length; i++){
			if(results[i].parentId != "-100"){
				tempGeographies.push({
					id:results[i].id,
					name:results[i].name
				});
			}
		}
		setGeographies(tempGeographies);
	};
	
	const thisContainer = {
		display:"flex",
		width:"calc(50% - 40px)",
		backgroundColor:"#eee",
		borderRadius:"4px",
		minHeight:"200px",
		marginLeft:"30px",
		flexDirection:"column",
		paddingBottom:"30px"
	};
	
	const titlePanel = {
		display:'flex',
		width:"calc(100% - 20px)",
		alignItems:"center",
		justifyContent:"space-between",
		color:"black",
		height:"40px",
		fontSize:"14px",
		marginLeft:"10px"
	};
	
	const blueButton = {
		display:"flex",
		width:"100px",
		height:"20px",
		backgroundColor:DEFAULT_BLUE,
		borderRadius:"15px",
		color:"white",
		fontSize:"12px",
		cursor:"pointer",
		marginRight:"10px",
		marginTop:"0px",
		alignItems:"center",
		justifyContent:"space-around",
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)',
	};
	
	const rowContainer = {
		display:"flex",
		width:"calc(100% - 40px)",
		marginLeft:"20px",
		flexDirection:"column",
		marginTop:"10px"
	};
	
	const itemRow = {
		display:"flex",
		height:"40px",
		marginBottom:"1px",
		backgroundColor:"white",
		alignItems:'center',
		paddingLeft:"10px",
		justifyContent:"space-between",
		fontSize:"12px",
	};
	
	const goEdit = (editId, editName) => {
		setChildId(editId);
		setChildName(editName);
		functions.getObjectFromAjax("/resolution/geography?id=" + editId,  null, populateChild);
		setChildEditDisplay("flex");
	};
	
	const populateChild = (child) => {
		if(child){
			refChildCode.current.value = child.code;
			refChildName.current.value = child.name;
			refChildDescription.current.value = child.description;
			if(child.isCountry === true){
					refChildIsCountry.current.value="Y";
				}
				else{
					refChildIsCountry.current.value="N";
				}
		}
	};
	
	const rowDisplay = geographies.map((item, index) => 
		<div style={itemRow}>
			{item.name}
			<div style={blueButton} onClick={() => {goEdit(item.id, item.name)}}>
				Edit
			</div>
		</div>
	);
	
	const childEditDisplayPanel = {
		display:childEditDisplay,
		position:"absolute",
		right:"30px",
		top:"100px",
		width:"600px",
		backgroundColor:"white",
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)'
	};
	
	const getChildTitle = () => {
		return "Child Details: " + childName
	};
	
	const resetBoxDisplay = () => {
		setChildEditDisplay("none");
		setChildName("New");
		setChildId("-100");
		refChildCode.current.value = "";
		refChildName.current.value = "";
	};
	
	const clickChildCancel = () => {
		resetBoxDisplay();
	}; 
	
	const clickChildSave = () => {
		goSubmit();
	};
	
	const clickChildDelete = () => {
		goDelete();
	};
	
	const getSubmitObject = () => {
		let tempIsCountry = false;
		if(refChildIsCountry.current.value === "Y"){
			tempIsCountry = true;
		}
		let submitObject = {
			id:childId,
			code:refChildCode.current.value,
			name:refChildName.current.value,
			description:refChildDescription.current.value,
			isCountry:tempIsCountry,
			parentId:id
		};
		return submitObject;
	}
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolution/geographysave", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		loadChildren();
		resetBoxDisplay();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolution/geographydelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	return (
		<div style={thisContainer}>
			<div style={titlePanel}>
				Child Geographies
				<div style={blueButton} onClick={() => {goEdit('-100', 'New');}}>
					Add
				</div>
			</div>
			<div style={rowContainer}>
				{rowDisplay}
			</div>
			
			<div style={childEditDisplayPanel}>
				<EditChildPanel
					title={getChildTitle()}
						componentRows = {childComponentRows}
						clickChildCancel={clickChildCancel} 
						clickChildSave={clickChildSave}
						clickChildDelete={clickChildDelete}
				/>
			</div>
			
		</div>
		
	);
}